const IN = {
  countryConfig: {
    IBAN: {
      visible: false,
      label: "bankDetails.IBAN",
      required: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.idNumber",
      required: true,
    },
    accountNumber: {
      visible: true,
      required: true,
      label: "bankDetails.accountNumber",
    },
    swift: {
      label: "bankDetails.swift",
      visible: true,
      required: true,
    },
    refBank: {
      label: "bankDetails.refBank",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { IN };
